export default __webpack_public_path__ + "static/media/react.6098d74f.svg";